var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.sessionURL)?_c('div',{staticClass:"edge-auditor__wrapper"},[_c('div',{staticClass:"edge-auditor__content"},[_c('iframe',{attrs:{"id":"edge-auditor__iframe","src":_vm.sessionURL,"title":"Edge Auditor"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }